import { cloneJSON } from "./clone-deep";
import { getPascalCase } from "./pascal-case";

export default {
  cloneJSON,
  getPascalCase
};
